import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getConfiguredLabel } from "../../common/commonHelper";
import { DataTypes, TemplateTypes } from "../../common/constants";
import { addButton, cancelButton, DocumentsPage } from "../../common/labelConstants";
import { getTemplate } from "../../store/template/templateSlice";
import SlbPopUp from "../controls/slbPopUp";
import { RenderForm } from "../jsonSchemaForm/formRenderer";
import { GetFormTemplateData, editCascadingFieldsHandler } from "../../common/controlHelper";
import { ComponentLoader } from "../loader/componentLoader";

const _props = {
    show: false,
    setShowPopup: () => { },
    title: '',
    onAddClick: () => { },
    form: {},
    controls : [],
    fileData:{}
}
export function MetaDataPopup(props = _props) {
    const form = props.form
    const dispatch = useDispatch();
    const [cascadedFields, setCascadedFields] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const fields = await editCascadingFieldsHandler(props.controls, props.fileData, dispatch);
            setCascadedFields(fields);
            const data = GetFormTemplateData(fields, props.fileData);
            return data
        };
        if (props.fileData && Object.keys(props.fileData).length !== 0) {
            fetchData().then((data) => {
                form.reset(data);
            });
        }
    }, []);


    return (
      <SlbPopUp
        show={props.show}
        title={
          props.fileData && !cascadedFields.length > 0
            ? "Loading..."
            : props.title
        }
        buttons={{
          cancel: {
            label: getConfiguredLabel(DocumentsPage, cancelButton),
            onClick: (event) => {
              form.reset();
              props.setShowPopup(false);
            },
          },
          ok:
            props.fileData && !cascadedFields.length > 0
              ? {}
              : {
                  label: getConfiguredLabel(DocumentsPage, addButton),
                  onClick: (event) => {
                    form.handleSubmit(props.onAddClick)();
                  },
                },
        }}
      >
        {!props.fileData ? 
          <RenderForm form={form} fields={props.controls} /> :
            cascadedFields.length > 0 ? 
            <RenderForm form={form} fields={cascadedFields} /> : 
            <ComponentLoader />
        }
      </SlbPopUp>
    );
}